import { useMutation } from "react-query";
import { addCameraType1 } from "../../../../../actions/Utilities/CameraType1";
import { toast } from "components/toastNotification";
import { ICameraType1 } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateCameraType1, cameraType1ReFetching } from "../atoms/atoms";

const useAddCameraType1 = () => {
  const setActionAddState = useSetRecoilState(addStateCameraType1);
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType1ReFetching);
  const { mutate } = useMutation(
    (NewData: ICameraType1) => addCameraType1(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Camera Type 1 failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera Type 1 Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera Type 1 Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Camera Type 1 failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Camera Type 1 failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Adding Camera Type 1 failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Camera Type 1 failed", res, "error");
          }
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Camera Type 1 failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddCameraType1;
